/**
 * Décodage du QR « panier » Scan & Go présenté en caisse.
 *
 * Le QR est produit par la PWA client (pages/panier/index.vue) et ne porte que
 * des couples [code-barres, quantité] : aucun prix, aucun libellé. La caisse
 * recalcule tout depuis sa propre base - c'est elle qui fait foi.
 *
 * Forme du payload :
 *   { soc: "<clé de licence>", mag: "<pid magasin>", l: [["3701527401260", 1], ...] }
 *
 * ⚠️ `soc` porte la clé de licence, PAS le code société (nommage hérité de la PWA).
 * Elle n'est pas vérifiable côté caisse aujourd'hui : aucune société n'a de ligne
 * dbparms typeparams='authscango'. Le champ est donc lu mais pas contrôlé.
 */

/** Le code-barres du QR et celui de la caisse sortent tous deux de la colonne ar_ref. */
export const normaliserEan = (v) => String(v === null || v === undefined ? "" : v).trim();

/**
 * @param {string} txt texte brut (douchette, webcam ou, plus tard, WebSocket)
 * @returns {{soc: string, mag: string, l: Array}|null} null si ce n'est pas un panier
 */
export const parsePayloadScanGo = (txt) => {
    const s = String(txt || "").trim();
    /* Garde bon marché : évite un JSON.parse sur chaque code-barres scanné. */
    if (s.length < 2 || s.charAt(0) !== "{") return null;

    let o;
    try {
        o = JSON.parse(s);
    } catch (e) {
        return null;
    }

    if (!o || typeof o !== "object" || Array.isArray(o)) return null;
    if (!Array.isArray(o.l) || o.l.length === 0) return null;
    if (!o.mag) return null;

    const lignes = [];
    for (const entree of o.l) {
        if (!Array.isArray(entree) || entree.length < 2) return null;
        const ean = normaliserEan(entree[0]);
        const qte = parseFloat(entree[1]);
        if (ean === "" || !isFinite(qte) || qte <= 0) return null;
        lignes.push([ean, qte]);
    }

    return { soc: String(o.soc || ""), mag: String(o.mag), l: lignes };
};
